module.exports = __webpack_public_path__ + "static/biz-oriented-87120b8638362d79d245526944b5b42b.svg";